// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__keMxy","checked":"Radio_checked__9YRB8"};